// removed by extract-text-webpack-plugin
module.exports = {"overrideBlock":"overrideBlock","overrideBlock_cell":"overrideBlock_cell"};


//////////////////
// WEBPACK FOOTER
// ./src/view/common/AprroveCustomizeIcons/style.scss
// module id = 1275
// module chunks = 0